import React, { useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import Bg from '../../Assets/images/hhand1.png';
import Bgs from '../../Assets/images/hhand2.png';
import Star from '../../Assets/images/star.svg';
import Googles from '../../Assets/images/ggp.svg';
import Apples from '../../Assets/images/aap.svg';
import Button from '../SelectValue/Button';
import { PlayArrow, Apple, Close } from '@mui/icons-material';

function TopSec() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activeBackground, setActiveBackground] = useState(0);

  const handlePrev = () => {
    setActiveBackground((prev) => (prev === 0 ? 1 : 0));
  };

  const handleNext = () => {
    setActiveBackground((prev) => (prev === 1 ? 0 : 1));
  };

  const handlePopupToggle = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  return (
    <div className="body-bg relative overflow-hidden pt-[140px] sm:pt-[177px]">
      <div className="grid sm:grid-cols-3 gap-4">
        <div className="sm:col-span-2 mb-10 px-6 sm:px-24">
          <AnimatePresence mode="wait">
            {activeBackground === 0 ? (
              <motion.div
                key="content1"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.6 }}
              >
                <p className="inline-block bg-white p-3 text-[12px] font-[500] rounded-[32px] text-primary-color mb-4">
                  <img src={Star} alt="Star" className="inline" /> Empowering Ethics, Enriching Futures.
                </p>
                <h1 className="text-[24px] mb-6 font-[24px] text-text-color1 sm:text-[48px]">
                  Make and grow{" "}
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#FF75E8] to-[#8046F2]">
                    wealth the right way
                  </span>
                </h1>
                <p className="text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px]">
                  Collaborative savings designed for halal investment. Grow wealth with your community - transparently, intelligently, and riba-free.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">
                  <Button 
                  name="Start Saving Ethically" 
                  onClick={() => {
                        window.open("https://dashboard.halalwealth.co/sign-up/", "_blank", "noopener,noreferrer");
                      }}
                  />
                  <Button
                    name="Download Mobile App"
                    onClick={handlePopupToggle}
                    icon={
                      <span className="inline-flex items-center gap-1">
                        <PlayArrow className="text-white w-4 h-4" />
                        <span className="text-white text-sm">/</span>
                        <Apple className="text-white w-4 h-4" />
                      </span>
                    }
                  />
                </div>
              </motion.div>
            ) : (
              <motion.div
                key="content2"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.6 }}
              >
                <p className="inline-block bg-white p-3 text-[12px] font-[500] rounded-[32px] text-primary-color mb-4">
                  <img src={Star} alt="Star" className="inline" /> Empowering Ethics, Enriching Futures.
                </p>
                <h1 className="text-[24px] mb-6 font-[24px] text-text-color1 sm:text-[48px]">
                  ...and it doesn’t have to be{" "}
                  <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#FF75E8] to-[#8046F2]">
                    boring and slow
                  </span>
                </h1>
                <p className="text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px]">
                  Choose smarter, smoother, sharper.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">
                  <Button 
                  name="Start Saving Ethically" 
                  onClick={() => {
                        window.open("https://dashboard.halalwealth.co/sign-up/", "_blank", "noopener,noreferrer");
                      }}
                  />
                  <Button
                    name="Download Mobile App"
                    onClick={handlePopupToggle}
                    icon={
                      <span className="inline-flex items-center gap-1">
                        <PlayArrow className="text-white w-4 h-4" />
                        <span className="text-white text-sm">/</span>
                        <Apple className="text-white w-4 h-4" />
                      </span>
                    }
                  />
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <div className="relative px-10 sm:pt-20">
          <motion.img
            src={Bg}
            alt="home"
            className="hidden sm:block w-full h-auto"
            initial={{ opacity: 0, x: 100 }}
            animate={{
              opacity: 1,
              x: 0,
              y: [0, -10, 0], 
            }}
            transition={{
              opacity: { duration: 1, ease: "easeOut" },
              x: { duration: 1, ease: "easeOut" },
              y: { duration: 3, repeat: Infinity, ease: "easeInOut" },
            }}
          />
          <motion.img
            src={Bgs}
            alt="home"
            className="sm:hidden block w-full h-auto"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          />
        </div>
      </div>

      <div className="absolute top-1/2 left-0 transform -translate-y-1/2 flex justify-between w-full px-2 sm:px-4">
        <button
          onClick={handlePrev}
          className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 focus:outline-none"
          aria-label="Previous background"
        >
          <svg className="w-6 h-6 text-primary-color" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={handleNext}
          className="bg-white p-2 rounded-full shadow-md hover:bg-gray-100 focus:outline-none"
          aria-label="Next background"
        >
          <svg className="w-6 h-6 text-primary-color" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      <AnimatePresence>
        {isPopupOpen && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
              className="bg-white p-6 rounded-lg shadow-lg relative flex flex-col items-center gap-4"
            >
              <button
                onClick={handlePopupToggle}
                className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 focus:outline-none"
                aria-label="Close popup"
              >
                <Close className="w-6 h-6" />
              </button>
              <h3 className="text-lg font-medium text-text-color1">Download Our App</h3>
              <div className="flex flex-row gap-4">
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src={Googles} alt="Google Play Store" className="w-32 h-auto" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src={Apples} alt="App Store" className="w-32 h-auto" />
                </a>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default TopSec;
